import { useEffect, useState, useContext } from 'react';

export default function useAudioQuestion({
  question,
  onAnswer,
  audioAutoPlayerContext,
  modalRef,
}) {
  const [state, setState] = useState({
    answer: null,
    questionTitle: null,
    options: null,
    modalWidth: 0,
  });

  const actions = {
    setState: (newState) => {
      setState((previousState) => ({ ...previousState, ...newState }));
    },
    onOptionSelect({ target: { value } }) {
      const answer = {
        selected: state.options[value].text,
        correct: state.options[value].correct,
      };
      if (!answer.correct) {
        answer.rightAnswer = state.options.find(
          (option) => option.correct
        ).text;
      }
      onAnswer({ ...answer, id: question.id, title: question.title });

      actions.setState({ answer });
    },
  };

  useEffect(() => {
    question.options = randomizeOrder(question.options);
    const audioQueue = question.options.map((option) => option.audio);
    audioQueue.unshift(question.title.audio);
    if (!audioQueue.some((audio) => !audio)) {
      audioAutoPlayerContext.actions.createQueue(audioQueue);
    }
    actions.setState({
      questionTitle: question.title,
      options: question.options,
    });
  }, [question]);

  useEffect(() => {
    const currentAudio = audioAutoPlayerContext.state.currentAudio;
    if (currentAudio && state.questionTitle) {
      actions.setState({
        questionTitle: {
          ...state.questionTitle,
          playing: currentAudio == state.questionTitle?.audio,
        },
        options: state.options?.map((option) => ({
          ...option,
          playing: currentAudio == option.audio,
        })),
      });
    }
  }, [audioAutoPlayerContext.state.currentAudio]);

  useEffect(() => {
    if (typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(() => {
        if (modalRef.current) {
          actions.setState({ modalWidth: modalRef.current.offsetWidth });
        }
      });

      if (modalRef.current) {
        observer.observe(modalRef.current);
      }

      return () => {
        if (modalRef.current) {
          observer.unobserve(modalRef.current);
        }
      };
    } else {
      actions.setState({ modalWidth: 300 });
    }
  }, []);

  return { state, actions };
}

function randomizeOrder(list) {
  return [...list].sort(() => (Math.random() > 0.5 ? 1 : -1));
}

function fakeQuestionAudios(question) {
  console.log('fakeQuestionAudios');
  const optionAudios = ['/acabaElVerano.m4a', '/acabaElOtonio.m4a'];
  const questionWithAudio = {
    ...question,
    title: { text: question.title.text, audio: '/acabaElVeranoOElOtonio.m4a' },
    options: question.options.map((option, idx) => ({
      ...option,
      audio: optionAudios[idx],
    })),
  };
  console.log('[question with aaudio]', questionWithAudio);
  return questionWithAudio;
}
